import { makeObservable, observable, observableRef } from 'mobx';
import { MunsellMetric } from '@cutwise/color-visualizer';

import { ProductType } from '@/product/constants/productTypes';
import Product from '@/product/entity/Product';

import { GemTypeId } from '../constants/GemTypeId';

export class GemModel extends Product {
  declare entityType: ProductType;

  constructor(...args: ConstructorParameters<typeof Product>) {
    super(...args);

    this.entityType = ProductType.Gem;
  }

  gemType!: GemTypeId;

  isccNbs!: Nullable<string>;
}

export default class Gem extends GemModel {
  declare gemType: GemTypeId;

  declare isccNbs: Nullable<string>;

  fancyColorGrade?: MunsellMetric;

  constructor(modelData: GemModel) {
    super(modelData);

    makeObservable(this, {
      gemType: observable,
      isccNbs: observable,
      fancyColorGrade: observableRef,
    });

    this.gemType = modelData.gemType;
    this.isccNbs = modelData.isccNbs ?? null;

    if (modelData._embedded?.scores?.hue && MunsellMetric.isValidMetric(modelData._embedded.scores.hue)) {
      this.fancyColorGrade = new MunsellMetric(modelData._embedded.scores.hue);
    }
  }
}
